/* Folds the EasySearch "fits these cars" table behind a button: the product
   page was ~15,000px tall on a phone because the table printed every car. */
(() => {
  'use strict';
  if (window.SenfUx) return;
  window.SenfUx = true;
  const AR = !String(document.documentElement.lang || 'ar').toLowerCase().startsWith('en');
  const t = (a, e) => (AR ? a : e);

  function fold() {
    const holder = document.querySelector('.easysearch-ft-table-holder, .easysearch-ft-holder .table-responsive');
    if (!holder) return false;
    const box = holder.closest('.easysearch-ft-holder') || holder.parentElement;
    if (!box) return false;
    if (box.classList.contains('senf-fit')) return true;
    const rows = box.querySelectorAll('tbody tr').length || box.querySelectorAll('tr').length;
    if (rows < 12) return false; // the widget is still filling the table
    box.classList.add('senf-fit');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'senf-fit__more';
    const label = () => {
      const open = box.classList.contains('is-open');
      button.innerHTML = '';
      button.append(document.createTextNode(open ? t('إخفاء القائمة', 'Hide the list') : t('عرض كل السيارات المتوافقة', 'Show every fitting car')));
      if (!open && rows) {
        const count = document.createElement('span');
        count.textContent = '(' + rows + ')';
        button.append(count);
      }
      button.setAttribute('aria-expanded', String(open));
    };
    button.addEventListener('click', () => {
      const opening = !box.classList.contains('is-open');
      box.classList.toggle('is-open');
      label();
      if (!opening) box.scrollIntoView({ block: 'nearest' });
    });
    label();
    box.appendChild(button);
    return true;
  }

  function watch() {
    if (fold()) return;
    let tries = 0;
    const timer = setInterval(() => { if (fold() || ++tries > 60) clearInterval(timer); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
  else watch();
})();